import { createStyles } from '@mantine/core';

export type MissionBadgeSize = 'small' | 'medium' | 'large';

/** Rendered pixel dimensions per badge size (hexagon is ~square). */
export const MISSION_BADGE_DIMENSIONS: Record<MissionBadgeSize, number> = {
  small: 54,
  medium: 80,
  large: 150,
};

// [width, height, vertical-shift]
export const MISSION_BADGE_BGR_DIMENSIONS: Record<MissionBadgeSize, [number, number, number]> = {
  small: [105/2, 117/2, -2],
  medium: [156/2, 173/2, -4],
  large: [293/2, 326/2, -9],
};

const REWARD_FONT_SIZE: Record<MissionBadgeSize, number> = {
  small: 20,
  medium: 28,
  large: 55,
};

export const useStyles = createStyles((theme, { size }: { size: MissionBadgeSize }) => {
  const dimension = MISSION_BADGE_DIMENSIONS[size];
  const bgrPosition = MISSION_BADGE_BGR_DIMENSIONS[size][2];

  return {
    badge: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: dimension,
      height: dimension,
      flexShrink: 0,
    },
    badgeBgr: {
      position: 'absolute',
      bottom: bgrPosition,
      left: 0,
      zIndex: 1,
    },
    rewardValue: {
      position: 'relative',
      color: theme.white,
      zIndex: 2,
      fontSize: REWARD_FONT_SIZE[size],
      lineHeight: 1,
      textShadow: '0 2.5px 2.7px rgba(0, 0, 0, 0.35)',
      // Using SVG filter for the inset text shadow
      filter: 'url(#rewardValueShadow)',
      backgroundClip: 'text',
    },
    badgeIcon: {
      position: 'relative',
      zIndex: 2,
    },
  };
});
